import { Modal, Button, Form, Col, Row } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import { useSelector,useDispatch } from "react-redux";
import {Icon, listIcons} from '@iconify/react';
import APICom from '../../utils/helpers/APICom.js';
import PersistStorage from "../../utils/helpers/PersistStorage.js";
import DateTimeUtils from '../../utils/DateTimeUtility.js';

const MultiSchedule = (props) => {
  const { loginData } = useSelector((store) => store.login);
  const { ASCSSettingData, FundingSourceData, MvRouteSettingData} = useSelector((store) => store.combinedata);
  const [multischModalShow, setMultischModalShow] = useState(props.bMultiScheduleShow);
  const [multiSchDates, setMultiSchDates] = useState({from:"", to:""});
  const [holidayList, setHolidayList] = useState([]);
  const [holidayMsg, setHolidayMsg] = useState([]);
  const [manageDaysMultiSch, setManageDaysMultiSch] = useState([
    {Day:"Sunday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Monday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Tuesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Wednesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Thursday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Friday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
    {Day:"Saturday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false}
  ]);
  const [daysIncluded, setDaysIncluded] = useState([]);
  const [isTimeValidated, setIsTimeValidated] = useState({isValid:true, invalidData:[]});
  const [ShowAPILoader, setShowAPILoader] = useState(false);
  const [scheduledDisplayDays, setScheduledDisplayDays] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [neverExpireFlagMultiSch, setNeverExpireFlagMultiSch] = useState(false);
  const [exclusionType, setExclusionType] = useState("All");
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [modalFooterHTML, setModalFooterHTML] = useState(
    <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
      OK
    </Button>
  );
  const xCancelSourceForGrid = useRef(null);
  const systemDateTimeRef = useRef({time:"", date:"", givenDate:"", givenTime:""});
  const calculatedTimeCheck = useRef(0);

  useEffect(() => {
    try{
      getCurrentSystemDateTime();
      getHolidaySchedule();
    }
    catch(err){console.log(err);}

  }, []);

  useEffect(()=>{
    try{
      if(props.scheduleJSONData.mainData !== "")
      {
        let prevData = PersistStorage.retrieve("temporaryMultiDetails", false);
        if(prevData && !props.isEditMode)
        {
          let dataRange = prevData.range;

          setManageDaysMultiSch(prevData.multiSchData.managed);
          setScheduledDisplayDays(prevData.multiSchData.displayed);
          setMultiSchDates(prevData.range);
          getDaysInRange(dataRange.from, dataRange.to);
          setNeverExpireFlagMultiSch(prevData.neverExpire);
          setExclusionType("All");
        }
        else
        {
          let dataRange = props.scheduleJSONData.range;

          setManageDaysMultiSch(props.scheduleJSONData.multiSchData.managed);
          setScheduledDisplayDays(props.scheduleJSONData.multiSchData.displayed);
          setMultiSchDates(props.scheduleJSONData.range);
          getDaysInRange(dataRange.from, dataRange.to);
          setNeverExpireFlagMultiSch(props.scheduleJSONData.neverExpire);
          setExclusionType("All");
        }
      }
    }
    catch(err){console.log(err);}

  }, [props.scheduleJSONData]);

  function toMilitaryTime(timeString) {
    try{
      // Split the time string into time and period (AM/PM)
      let [time, period] = timeString.split(" ");
      let [hours, minutes] = time.split(":").map(num => parseInt(num));
    
      // Convert to 24-hour time format
      if (period === "PM" && hours !== 12) {
        hours += 12; // Convert PM to 24-hour format
      }
      if (period === "AM" && hours === 12) {
        hours = 0; // Convert 12 AM to 00:00
      }
    
      // Format hours and minutes to two digits (e.g., 1:5 becomes 01:05)
      let militaryTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      
      return militaryTime;
    }
    catch(err){console.log(err); return timeString;}
  };

  const getCurrentSystemDateTime = async () => {
    try{
      let serverDateTime = await DateTimeUtils.getCurrentSystemDateTime();
      const regex = /(\d{2}:\d{2})(AM|PM)$/;
      // Match the time and AM/PM
      const match = serverDateTime.match(regex);
      if(match)
      {
        let systemTime = DateTimeUtils.toMilitaryTime(match[1]+" "+match[2], 0);
        let [month, day, year] = (serverDateTime.split(" ")[0]?.split("/") || ['','','']);
        let systemDate = year+"-"+month+"-"+day;
        systemDateTimeRef.current = {time:(systemTime.military), date:systemDate, givenDate: serverDateTime.split(" ")[0], givenTime: serverDateTime.split(" ")[1]};
        let dateToMultiSch = (props.date && props.date !== ""? new Date(props.date+" 00:00:00") : new Date(systemDate+" 00:00:00"));
        dateToMultiSch.setDate(dateToMultiSch.getDate()+6);
        const newYear = dateToMultiSch.getFullYear();
        const newMonth = String(dateToMultiSch.getMonth() + 1).padStart(2, '0');
        const newDay = String(dateToMultiSch.getDate()).padStart(2, '0');
        if(props.date && props.date !== "" && props.scheduleJSONData.range === "")
        {
          setMultiSchDates({...multiSchDates, from:props.date, to:`${newYear}-${newMonth}-${newDay}`});
          getDaysInRange(props.date, `${newYear}-${newMonth}-${newDay}`);
        }
        else
        {
          if(props.scheduleJSONData.range === "")
          {
            setMultiSchDates({...multiSchDates, from:systemDate, to:`${newYear}-${newMonth}-${newDay}`});
            getDaysInRange(systemDate, `${newYear}-${newMonth}-${newDay}`);
          }
        }
        
      }
      else
      {
        if(props.scheduleJSONData.range === "")
        {
          setMultiSchDates({...multiSchDates, from:"", to:""});
        }
      }

    } catch(err){console.log(err);}
  }

  function findDaysInRange(from, to, dayIndex) {
    const startDate = new Date(from+"T00:00:00");
    const endDate = new Date(to+"T00:00:00");
    const daysInRange = [];
  
    // Adjust for time portion, setting both to the start of their respective days
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    let alignedDateStart = new Date(startDate)
    while (alignedDateStart.getDay() !== dayIndex) {
      alignedDateStart.setDate(alignedDateStart.getDate() + 1); // Move one day forward
    }
    // Iterate through the date range
    for (let currentDate = new Date(alignedDateStart); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 7)) {
      const formattedDate = 
        (currentDate.getMonth() + 1).toString().padStart(2, '0') + '/' + 
        currentDate.getDate().toString().padStart(2, '0') + '/' + 
        currentDate.getFullYear();
      daysInRange.push(formattedDate);

    }
  
    return daysInRange;
  }

  const getHolidaySchedule = async () =>{
    try{
      let data = {
        "iATSPID": parseInt(props.AffID)
      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/GetHolidays", "post", {}, data, xCancelSourceForGrid.current);

      if(response && response.error.length === 0)
      {
        if(response.data.length > 0 && response.data !== "")
        {
          let dateList = {};
          for(let k = 0; k < response.data.length; k++)
          {
            let dateTemp = (response.data[k].Date.includes("T") ? response.data[k].Date.split("T")[0] : response.data[k].Date.split(" ")[0]);
            dateList[dateTemp] = {Date:dateTemp, ExcludedHolidays:response.data[k].ExludedHolidays};
          }
          setHolidayList(dateList);
        }
      }
      else
      {
        // setModalHeaderText("Holiday Schedule Error");
        // setModalBodyHTML(<b>{response.error}</b>);
        // setModalFooterHTML(
        //   <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
        //     OK
        //   </Button>
        // );
        // setShowDynamicModal(true);
        setHolidayList([]);
      }
    }
    catch(err){console.log(err);}
  };

  const handleResetParameters = () => {
    try{
      setManageDaysMultiSch([
        {Day:"Sunday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Monday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Tuesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Wednesday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Thursday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Friday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false},
        {Day:"Saturday", Date:"", Checked:false, WillCall:false, Appt:"", PUTime:"09:00", isReturnTrip:false, ReturnWillCall:false, ReturnAppt:"", ReturnTime:"09:00", schType:"sch", isHoliday:false}
      ]);
      setScheduledDisplayDays([]);
      setIsTimeValidated({isValid:true, invalidData:[]});
      setNeverExpireFlagMultiSch(false);
      setExclusionType("All");
    }
    catch (err) {console.log(err);}
  };

  const handleHideMultiSchModal = async (type = "") => {
    try{
      if(type === "hide")
      {
        let dataRange = null;
        let prevData = PersistStorage.retrieve("temporaryMultiDetails", false);

        if(prevData && prevData.mainData !== "")
        {
          dataRange = prevData.range;
          setManageDaysMultiSch(prevData.multiSchData.managed);
          setScheduledDisplayDays(prevData.multiSchData.displayed);
          setMultiSchDates(prevData.range);
          getDaysInRange(dataRange.from, dataRange.to);
          setNeverExpireFlagMultiSch(prevData.neverExpire);
          setExclusionType("All");
          setMultischModalShow(false); props.setShowMultiSchedule(false);
        }
        else
        {
          await getCurrentSystemDateTime();
          handleResetParameters();
          setMultischModalShow(false); props.setShowMultiSchedule(false);
        }
      }
      else
      {
        let dateFromMultiSch = systemDateTimeRef.current.date;
        let dateToMultiSch = new Date(dateFromMultiSch+" 00:00:00");
        dateToMultiSch.setDate(dateToMultiSch.getDate()+6);
        const newYear = dateToMultiSch.getFullYear();
        const newMonth = String(dateToMultiSch.getMonth() + 1).padStart(2, '0');
        const newDay = String(dateToMultiSch.getDate()).padStart(2, '0');
        if(type!=="clear" && type !== "date"){
          setMultischModalShow(false); props.setShowMultiSchedule(false);
        }
        else{
          setShowDynamicModal(false); 
          props.setScheduleJSON({mainData: "", multiSchData: "", range:"", neverExpire:false});
        }
        if(type !== "date"){setMultiSchDates({...multiSchDates, from:systemDateTimeRef.current.date, to:`${newYear}-${newMonth}-${newDay}`});}
        handleResetParameters();
      }
    }
    catch(err){console.log(err); setMultischModalShow(false); props.setShowMultiSchedule(false);}
  };

  const handleClearMultiSchedule = (e)=>{
    try{
      setModalHeaderText("Clear Standing Order");
      setModalBodyHTML("Are you sure you want to clear the schedule you made for this request?");
      setModalFooterHTML(
        <>
          <Button variant='dark' className="border-0" onKeyDown={(e)=>{
              if(e.key === "Enter"){handleHideMultiSchModal("clear");}
            }} onClick={()=>{handleHideMultiSchModal("clear")}}>
            Yes
          </Button>
          <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false);}}>
            No
          </Button>
        </>
      );
      setShowDynamicModal(true);
    }
    catch(err){console.log(err);}
  };

  const convertDate = (dateString) => {
    try{
      const [year, month, day] = dateString.split("-");
      return `${month}/${day}/${year}`;
    }
    catch(err){console.log(err); return dateString;}
  };

  const handleApplyMultiSchedule = async (e, multischeduleExcludedflag = false) => {
    try{
      let vPreSchDays = "";
      let exclusionList = [];
      if(manageDaysMultiSch[0].Checked && manageDaysMultiSch[0].Date !== "N/A")
      {
        vPreSchDays += "S";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[1].Checked && manageDaysMultiSch[1].Date !== "N/A")
      {
        vPreSchDays += "M";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[2].Checked && manageDaysMultiSch[2].Date !== "N/A")
      {
        vPreSchDays += "T";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[3].Checked && manageDaysMultiSch[3].Date !== "N/A")
      {
        vPreSchDays += "W";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[4].Checked && manageDaysMultiSch[4].Date !== "N/A")
      {
        vPreSchDays += "T";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[5].Checked && manageDaysMultiSch[5].Date !== "N/A")
      {
        vPreSchDays += "F";
      }
      else
        vPreSchDays += " ";
      if(manageDaysMultiSch[6].Checked && manageDaysMultiSch[6].Date !== "N/A")
        {
          vPreSchDays += "S";
        }
        else
          vPreSchDays += " ";
      for(let k = 0; k < scheduledDisplayDays.length; k ++)
      {
        if(scheduledDisplayDays[k].schType === "exc")
        {
          exclusionList.push({Date: (scheduledDisplayDays[k].Date + " - " + scheduledDisplayDays[k].Day), isHolidayExc: (scheduledDisplayDays[k].isHoliday)})
        }
      }
      let MultiScheduleIdentiferNumber = "";
      if(props.scheduleJSONData.mainData !== "")
      {
        if(props.scheduleJSONData.mainData.MultiScheduleIdentifier)
        {
          MultiScheduleIdentiferNumber = props.scheduleJSONData.mainData.MultiScheduleIdentifier;
        }
      }
      else
      {
        MultiScheduleIdentiferNumber = (new Date()).getTime();
      }
      const sharedParams = {
        Exclusions: exclusionList,
        vPreSch: vPreSchDays,
        MultiScheduleIdentifier: MultiScheduleIdentiferNumber,
      };
      let filteredArr = scheduledDisplayDays.filter(item => item.Checked && item.Date !== "N/A" && item.Date !== "");
      let scheduleComponents = filteredArr.map((item, index) =>{

        let dayofWeek = "";
        switch(item.Day){
          case "Monday":
            dayofWeek = 2;
            break;
          case "Tuesday":
            dayofWeek = 3;
            break;
          case "Wednesday":
            dayofWeek = 4;
            break;
          case "Thursday":
            dayofWeek = 5;
            break;
          case "Friday":
            dayofWeek = 6;
            break;
          case "Saturday":
            dayofWeek = 7;
            break;
          case "Sunday":
            dayofWeek = 1;
            break;
          default:
            dayofWeek = 0;
        }
        let targetDate = (item.Date !== "" && item.Date !== "N/A" ? item.Date : 
          findDay(multiSchDates.from, multiSchDates.to, index));
        let [month, day, year] = targetDate ?  targetDate.split("/"): ["","",""]; 
        let StartDateTime = targetDate+" "+item.PUTime;
        let EndDateTime = targetDate+" 00:00:00";
        let apptTime = (item.Appt !== "" ? targetDate+" "+item.Appt : EndDateTime);
        let returnStartDateTime = targetDate+" "+item.ReturnTime;
        let returnApptDateTime = (item.ReturnAppt !== "" ? targetDate+" "+item.ReturnAppt : targetDate+" 00:00:00");
        return {
          dayName: item.Day,
          dayNumber: dayofWeek,
          startTime: StartDateTime,
          apptTime: apptTime,
          endTime: EndDateTime,
          bApptTime: (item.Appt !== "" ? true:false),
          willcall: item.WillCall,
          breturnleg: item.isReturnTrip,
          _returnmultischedule: {
            dayName: item.Day,
            dayNumber: dayofWeek,
            startTime: returnStartDateTime,
            endTime: (neverExpireFlagMultiSch ? "01/01/1900 00:00:00":EndDateTime),
            apptTime: returnApptDateTime,
            bApptTime: (item.ReturnAppt !== ""? true : false),
            willcall: item.ReturnWillCall,
            _returnmultischedule: null,
            breturnleg: false,
          },
          
        }
        
      });

      if(exclusionList.length > 0 && scheduleComponents.length > 0)
      {
        scheduleComponents = filterScheduleComponents(scheduleComponents, exclusionList)
      }

      let fromDate = convertDate(multiSchDates.from);
      let toDate = convertDate(multiSchDates.to);
      let Schedule = {
        from: (fromDate + " 00:00:00"),
        to: (neverExpireFlagMultiSch ? "01/01/1900 00:00:00" : (toDate + " 00:00:00")),
        infinitetodate: (toDate + " 00:00:00"),
        ScheduleItem: scheduleComponents
      };

      let tempJSONArr = { ...sharedParams, Schedule};
      if(scheduleComponents.length === exclusionList.length && !multischeduleExcludedflag)
      {
        setModalHeaderText("Multischedule Alert");
        setModalBodyHTML(<>{"Are you sure that you want to continue with all days excluded?"}</>);
        setModalFooterHTML(
          <>
            <Button variant='dark' className="border-0" onClick={(e)=>{handleApplyMultiSchedule(e, true);}}>
              Yes
            </Button>
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              No
            </Button>
          </>
        );
        setShowDynamicModal(true);
      }
      else
      {
        let data = {
          "ATSPID" : parseInt(props.AffID),
          "scheduleInfo": tempJSONArr.Schedule,
          "exclusions" : tempJSONArr.Exclusions
        };
        let response = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/CheckServiceHoursForStandingOrder", "post", {}, data, xCancelSourceForGrid.current);
        
        if(response && response.error.length === 0)
        {
          if(response.data === "")
          {
            PersistStorage.save("temporaryMultiDetails", {mainData: tempJSONArr, multiSchData: {managed: manageDaysMultiSch, displayed: scheduledDisplayDays}, range:multiSchDates, neverExpire:neverExpireFlagMultiSch}, 99, false);
            props.setScheduleJSON(prevState=>({...prevState, mainData: tempJSONArr, multiSchData: {managed: manageDaysMultiSch, displayed: scheduledDisplayDays}, range:multiSchDates, neverExpire:neverExpireFlagMultiSch}));
            handleHideMultiSchModal();
          }
          else
          {
            PersistStorage.save("temporaryMultiDetails", null, 99, false);
            setIsTimeValidated({isValid:false, invalidData:response.data});
          }
        }
        else
        {
          PersistStorage.save("temporaryMultiDetails", {mainData: tempJSONArr, multiSchData: {managed: manageDaysMultiSch, displayed: scheduledDisplayDays}, range:multiSchDates, neverExpire:neverExpireFlagMultiSch}, 99, false);
          props.setScheduleJSON(prevState=>({...prevState, mainData: tempJSONArr, multiSchData: {managed: manageDaysMultiSch, displayed: scheduledDisplayDays}, range:multiSchDates, neverExpire:neverExpireFlagMultiSch}));
          handleHideMultiSchModal();
        }
      }
    }
    catch(err){console.log(err);}
  };


  // Function to extract date part from datetime string
  function getScheduleItemDatePart(dateTimeString) {
      return dateTimeString.split(' ')[0].trim();
  }

  // Function to extract date part from datetime string
  function getExclusionItemDatePart(dateTimeString) {
      return dateTimeString.split('-')[0].trim();
  }

  // Function to filter scheduleComponents using exclusionList
  function filterScheduleComponents(scheduleComponents, exclusionList) {
      // Create a Set of excluded dates for faster lookup
      const excludedDates = new Set(
          exclusionList.map(exclusion => getExclusionItemDatePart(exclusion.Date))
      );
      
      // Filter out items that have startTime dates in the exclusion list
      const filteredComponents = scheduleComponents.filter(component => {
          const startTimeDate = getScheduleItemDatePart(component.startTime);
          return !excludedDates.has(startTimeDate);
      });
      
      return filteredComponents;
  }

  const handleMultiScheduleDaySelect = (index) =>{
    try{
      let manageDays = [...manageDaysMultiSch];
      manageDays[index].Checked = !manageDays[index].Checked;
      if(!manageDays[index].Checked)
      {
        manageDays[index].WillCall = false;
        manageDays[index].isReturnTrip = false;
        manageDays[index].ReturnWillCall = false;
        manageDays[index].Appt = "";
        manageDays[index].PUTime = "09:00";
        manageDays[index].ReturnAppt = "";
        manageDays[index].ReturnTime = "09:00";
      }
      
      let targetDate = (manageDaysMultiSch[index].Date !== "" && manageDaysMultiSch[index].Date !== "N/A" 
        ? manageDaysMultiSch[index].Date : findDay(multiSchDates.from, multiSchDates.to, index));

      let [month, day, year] = targetDate  && targetDate !== "N/A"?  targetDate.split("/"): ["","",""]; 
      let newTargetDate = (year !== "" ? (year+"-"+month+"-"+day) : "N/A");

      if(newTargetDate !== "N/A")
      {
        // let updatedSelectedDays = [...selectedDays];
        // if (updatedSelectedDays.some(item => item.Date === newTargetDate)) {
        //   // If the date is already in the array, remove it (deselect)
        //   updatedSelectedDays = updatedSelectedDays.filter((item) => item.Date !== newTargetDate);
        // } else {
        //   // If the date is not in the array, add it (select)
        //   updatedSelectedDays.push(manageDays[index]);
        // }
        if(Object.keys(holidayList).length > 0 && holidayList.hasOwnProperty(newTargetDate) && holidayList[newTargetDate].ExcludedHolidays === "false" && !holidayMsg.includes(targetDate))
        {
          manageDays[index].schType = "exc";
          manageDays[index].isHoliday = true;
          setHolidayMsg(prevDates => [...prevDates, targetDate]);
        }
        else
        {
          manageDays[index].isHoliday = false;
          manageDays[index].schType = "sch";
          if(holidayMsg.length > 0)
          {
            setHolidayMsg(prevDates => holidayMsg.filter((item) => item !== targetDate));
          }
        }
        // updatedSelectedDays.sort((a, b) => new Date(b.Date) - new Date(a.Date)); // Sort in descending order (latest to earliest)
        // setSelectedDays(updatedSelectedDays);
      }
      else
      {
        manageDays[index].schType = "sch";
      }

      if(manageDays[index].Checked)
      {
        manageDays[index].Date = findDay(multiSchDates.from, multiSchDates.to, index);
        if(systemDateTimeRef.current.givenDate === manageDays[index].Date)
          validateMinScheduleTimeDifference(manageDays[index].PUTime, manageDays[index].Date, manageDays[index].Day);
        let dates = findDaysInRange(multiSchDates.from, multiSchDates.to, index);
        if(dates.length > 1)
        {
          let newData = dates.map((date, index2)=>{
            let isHolidayDates = false;
            let formattedDate = (date.split("/")[2]+"-"+date.split("/")[0]+"-"+date.split("/")[1]);
            if(Object.keys(holidayList).length > 0 && holidayList.hasOwnProperty(formattedDate) && holidayList[formattedDate].ExcludedHolidays === "false" && !holidayMsg.includes(date))
            {
              isHolidayDates = true;
              manageDays[index].schType = "exc";
              manageDays[index].isHoliday = true;
            }
            else
            {
              isHolidayDates = false;
              manageDays[index].isHoliday = false;
              manageDays[index].schType = "sch";
            }
            return {Day:manageDays[index].Day, Date:date, Checked:manageDays[index].Checked, WillCall:manageDays[index].WillCall, 
              Appt:manageDays[index].Appt, PUTime:manageDays[index].PUTime, isReturnTrip:manageDays[index].isReturnTrip, 
              ReturnWillCall:manageDays[index].ReturnWillCall, ReturnAppt:manageDays[index].ReturnAppt, 
              ReturnTime:manageDays[index].ReturnTime, schType:manageDays[index].schType, isHoliday:isHolidayDates
            };
          });
          setScheduledDisplayDays(prevState => {
            const filteredNewData = (prevState !== "" ? (newData.filter(item => 
              !prevState.some(existingItem => 
                existingItem.Day === item.Day && existingItem.Date === item.Date
              )
            )) : newData);
            const combinedData = [...prevState, ...filteredNewData];
            combinedData.sort((a, b) => {
              let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
              let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
              const dateA = new Date(correctDateA+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
              const dateB = new Date(correctDateB+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
              return dateB - dateA; // latest to earliest
            });
            
            return combinedData;
          });
        }
        else
        {
          let isHolidayDates = false;
          let formattedDate = (dates[0].split("/")[2]+"-"+dates[0].split("/")[0]+"-"+dates[0].split("/")[1]);
          if(Object.keys(holidayList).length > 0 && holidayList.hasOwnProperty(formattedDate) && holidayList[formattedDate].ExcludedHolidays  === "false" && !holidayMsg.includes(dates[0]))
          {
            isHolidayDates = true;
          }
          let newData = {
            Day:manageDays[index].Day, Date:dates[0], Checked:manageDays[index].Checked, WillCall:manageDays[index].WillCall, 
            Appt:manageDays[index].Appt, PUTime:manageDays[index].PUTime, isReturnTrip:manageDays[index].isReturnTrip, 
            ReturnWillCall:manageDays[index].ReturnWillCall, ReturnAppt:manageDays[index].ReturnAppt, 
            ReturnTime:manageDays[index].ReturnTime, schType:manageDays[index].schType, isHoliday:isHolidayDates
          }
          setScheduledDisplayDays(prevState => {
            const filteredNewData = (prevState !== "" ? (prevState.some(existingItem => 
              existingItem.Day === newData.Day && existingItem.Date === newData.Date
            ) ? [] : [newData]) : [newData]);
            const combinedData = [...prevState, ...filteredNewData];
            combinedData.sort((a, b) => {
              let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
              let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
              const dateA = new Date(correctDateA+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
              const dateB = new Date(correctDateB+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
              return dateB - dateA; // latest to earliest
            });
            return combinedData;
          
          });
        }
      }
      else
      {
        let dateTemp = findDay(multiSchDates.from, multiSchDates.to, index);
        if(systemDateTimeRef.current.givenDate === dateTemp)
          setIsTimeValidated({isValid:true, invalidData: []});
        manageDays[index].Date = "";
        setScheduledDisplayDays(prevState => 
          prevState.filter((item2, i) => item2.Day !== manageDays[index].Day)
        );
      }
      setManageDaysMultiSch(manageDays);
    }
    catch(err){console.log(err);}
  };

  const findDay = (startDate, endDate, targetDay) => {
    try{
      const start = new Date(startDate + " 00:00:00");
      const end = new Date(endDate + " 00:00:00");
      // 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, etc.
      
      // Calculate the difference between the targetDay and startDay
      const daysUntilTarget = (targetDay - start.getDay() + 7) % 7;

      // Move start date to the next targetDay
      const nextTargetDate = new Date(start);
      nextTargetDate.setDate(start.getDate() + daysUntilTarget);
      
      // Ensure the date is within the range
      if (nextTargetDate <= end) {
        const formattedDate = 
          (nextTargetDate.getMonth() + 1).toString().padStart(2, '0') + '/' + 
          nextTargetDate.getDate().toString().padStart(2, '0') + '/' + 
          nextTargetDate.getFullYear();
        return formattedDate;
      }
      //if no specific date is found
      return "N/A";
    }
    catch(err){console.log(err); return "Error";}
  };

  function addsubtractMinutesFromMilitaryTime(time24, minutesToSubtract, minutesToAdd = 0) {
    try{
      // Split hours and minutes from the input time
      const [hours, minutes] = time24.split(':').map(Number);
      let totalMinutes = 0;
      if(minutesToAdd !== 0)
      {
        // Calculate total minutes and add
        totalMinutes = hours * 60 + minutes + minutesToAdd;
      }
      else
      {
        // Calculate total minutes and subtract
        totalMinutes = hours * 60 + minutes - minutesToSubtract;
      }
      

      // Handle cases where total minutes are negative
      if (totalMinutes < 0) {
        totalMinutes = (24 * 60 + totalMinutes) % (24 * 60); // Wraps around to previous day
      }

      // Convert back to hours and minutes
      const newHours = Math.floor(totalMinutes / 60) % 24;
      const newMinutes = totalMinutes % 60;

      // Pad hours and minutes with leading zeros if needed
      const paddedHours = String(newHours).padStart(2, '0');
      const paddedMinutes = String(newMinutes).padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}`;
    }
    catch(err){

      console.log(err); 
      return time24;
    }
    
  }

  const validateMinScheduleTimeDifference = async(timeInput, dateInput, day) => {
    try 
    {
      let tempSchTime = timeInput;
      let ScheduleTripMinTimeDiff = parseInt((JSON.parse(ASCSSettingData[parseInt(props.AffID)]).find((item) => item.SubTitle === "ScheduleTripMinTimeDiff")).value);
      if (ScheduleTripMinTimeDiff !== undefined) {

        let data = {
          "PickupDateTime": dateInput + " " + tempSchTime,
          "MinSchTimeDiff": ScheduleTripMinTimeDiff
        }
        
        let response = await APICom.fetchData("ReservationCoreURL","ValiateMinScheduleTimeDifference", "post", {}, data, xCancelSourceForGrid.current);

        if(response && response.error.length === 0)
        {
          if(response.data.responseCode === 400)
          {
            const combination = dateInput + " " + tempSchTime + " " + day;
            setIsTimeValidated(prevState=>{
              if(prevState.invalidData.includes(combination))
              {
                return prevState;
              }
              else
              {
                let invalidDataPast = prevState.invalidData;
                return {isValid : false, invalidData: [...invalidDataPast, combination]};
              }
            });
            
            // setModalHeaderText("Schedule Date & Time");
            // let pickupTimeText = (bCalculated ? "Pickup Time Calculated: " : "Pickup Time Entered: ");
            // setModalBodyHTML(<><p>{pickupTimeText}<b>{tempSchTime}</b></p><p className="m-0">{response.data.responseMessage}</p></>);
            // setModalFooterHTML(
            //   <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
            //     OK
            //   </Button>
            // );
            // setShowDynamicModal(true);
            // setModalClass("");
          }
          else if(response.data.responseCode === 200)
          {
            setIsTimeValidated({isValid:true, invalidData:[]});
          }
        }
      }
    } 
    catch (error) { 
      console.log(error);
      setIsTimeValidated({isValid:false, invalidData:[]});
    }
  };

  const getDaysInRange = (fromDate, toDate) => {
    try{
      const daysExist = Array(7).fill(false); // Initialize an array for all 7 days (0: Monday to 6: Sunday)
  
      // Parse the input dates and set the time to midnight
      const startDate = new Date(`${fromDate} 00:00:00`);
      const endDate = new Date(`${toDate} 00:00:00`);
    
      // Iterate through the date range
      for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
        const dayIndex = currentDate.getDay(); // Get day index (0: Sunday to 6: Saturday)
        daysExist[dayIndex] = true; // Convert to Monday (0) - Sunday (6)
      }
      let setofDays = daysExist.map((exists, index) => ({
        dayIndex: index,
        exists: exists,
      }));
      // Prepare the result as an array of objects
      setDaysIncluded(setofDays);
    }
    catch(err){console.log(err);}
    
  };

  const handleComputeNewPickupTime = (e, indexT, property) => {
    try{
      let selectedAff = parseInt(props.AffID);
      let selectedFS = parseInt(props.FSID);
      let passengerCount = props.paxCount;
      let clientInfo = props.clientInfoData;
      let dateGive = manageDaysMultiSch[indexT].Date;
      let correctFormatDate = (dateGive.split("/")[2]+"-"+dateGive.split("/")[0]+"-"+dateGive.split("/")[1]);
      let targetDate = (correctFormatDate+"T00:00:00");
      let fsSelection = (FundingSourceData && FundingSourceData[parseInt(selectedAff)] && FundingSourceData[parseInt(selectedAff)] !== undefined ? 
        JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []);
      const ERSASettingsData = (MvRouteSettingData && MvRouteSettingData[parseInt(selectedAff)] && MvRouteSettingData[parseInt(selectedAff)] !== "" ? 
        JSON.parse(MvRouteSettingData[parseInt(selectedAff)]) : []);
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let fsSelectedData = fsSelection.find((item)=>parseInt(item.FID) === parseInt(selectedFS));
      let selectedDay = new Date(targetDate);
      selectedDay = days[selectedDay.getDay()];

      // console.log(ERSASettingsData, fsSelectedData, selectedDay, clientInfo, passengerCount);
      const queryParams = new URLSearchParams(window.location.search);
      const tripSelected = queryParams.get('TripSelected')? true:false;
      let bIsUpdate = tripSelected;

      let FsApptTimeWindow = (fsSelectedData.dApptTimeWindow && fsSelectedData.dApptTimeWindow !== ""? fsSelectedData.dApptTimeWindow : 0);
      let FsServiceTimeAmb = (fsSelectedData.serviceTimeAmb && fsSelectedData.serviceTimeAmb !== "" ? fsSelectedData.serviceTimeAmb : 0);
      let FsSeviceTimeWC = (fsSelectedData.serviceTimeWC && fsSelectedData.serviceTimeWC !== "" ? fsSelectedData.serviceTimeWC : 0);
      let FstimeWindow = (fsSelectedData.timeWindow && fsSelectedData.timeWindow !== "" ? fsSelectedData.timeWindow : 0);
      let FsdEndTimeWindow = (fsSelectedData.dEndTimeWindow && fsSelectedData.dEndTimeWindow !== "" ? fsSelectedData.dEndTimeWindow : 0);
      let FsminRideTime = (fsSelectedData.minRideTime && fsSelectedData.minRideTime !== "" ? fsSelectedData.minRideTime : 0);
      let FsmaxRideTime = (fsSelectedData.maxRideTime && fsSelectedData.maxRideTime !== "" ? fsSelectedData.maxRideTime : 0);
      let FsadditionalSameLocAmb = (fsSelectedData.additionalSameLocAmb && fsSelectedData.additionalSameLocAmb !== "" ? fsSelectedData.additionalSameLocAmb : 0);
      let FsadditionalSameLocWC = (fsSelectedData.additionalSameLocWC && fsSelectedData.additionalSameLocWC !== "" ? fsSelectedData.additionalSameLocWC : 0); 

      let bDisableRideSharing = true;
      let MinutesToMinus = 0;
      let ApptWindow = 0;

      const manageDays = [...manageDaysMultiSch];

      if(ERSASettingsData.length > 0 && clientInfo && typeof clientInfo === "object")
      {
        let bFound = false;
        let index = 0;
        let selectedERSASetting = null;
        for(let k = 0; k < ERSASettingsData.length; k++)
        {
          if(ERSASettingsData[k].vScheduleDays && ERSASettingsData[k].vScheduleDays.trim() !== '')
          {
            let tempSettingDays = ERSASettingsData[k].vScheduleDays.trim().split('');
            bFound = (tempSettingDays.find((item)=>(item.toLowerCase()) === selectedDay.charAt(0).toLowerCase()) ? true : false);
            if(bFound)
            {
              index = k;
              break;
            }
          }
        }
        
        if(bFound)
        {
          bDisableRideSharing = ERSASettingsData[index].bDisableRideSharing;
          selectedERSASetting = ERSASettingsData[index];
        }
        else //No Setting found for current selected day
        {
          let defaultERSASettingData = ERSASettingsData.filter(item=>item.bDefault === true);
          if(defaultERSASettingData && defaultERSASettingData.length > 0)
          {
            bDisableRideSharing = ERSASettingsData[0].bDisableRideSharing;
            selectedERSASetting = ERSASettingsData[0];
          }
        }
        //PU Time = Appointment Time - Estimated Direct Ride Time from Map Source – Service Time (Amb , Wheel Chair) – Appointment Time window
        if(bDisableRideSharing)
        {
          MinutesToMinus = 0;
        }
        else
        {
          let min = 0;
          let max = 0;

          if(parseInt(FsminRideTime) > 0)
          {
            min = parseFloat(FsminRideTime);
          }
          else
          {
            min = (parseFloat(selectedERSASetting.MinimumRidTimeMin) <= 0 ? 0 : parseFloat(selectedERSASetting.MinimumRidTimeMin));
          }

          if(parseInt(FsmaxRideTime) > 0)
          {
            max = parseFloat(FsmaxRideTime);
          }
          else
          {
            max = (parseFloat(selectedERSASetting.MaxRideTimePer) <= 0 ? 0 : parseFloat(selectedERSASetting.MaxRideTimePer));
          }
          let EstTime = 0;
          let mrt = (EstTime * parseFloat(max) / 100);
          mrt = (mrt > parseFloat(min) ? mrt : parseFloat(min));
          MinutesToMinus = mrt;
        }
        
        //Wheelchair
        let serviceTime = 0;
        if(passengerCount.totalWC > 0)
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeWC && clientInfo.serviceTimeWC !== "" ? clientInfo.serviceTimeWC : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsSeviceTimeWC) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsSeviceTimeWC) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.WCServiceTime) * 2);
          }
        }
        else //Amb
        {
          serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeAmb && clientInfo.serviceTimeAmb !== "" ? clientInfo.serviceTimeAmb : 0));
          if(serviceTime > 0)
          {
            MinutesToMinus = MinutesToMinus + (serviceTime * 2);
          }
          else if(parseFloat(FsServiceTimeAmb) > 0)
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(FsServiceTimeAmb) * 2);
          }
          else
          {
            MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.AmbServiceTime) * 2);
          }
        }

        //Adding appointment time
        if(bIsUpdate && parseFloat(FsApptTimeWindow) > 0)
        {
          MinutesToMinus = MinutesToMinus + parseFloat(FsApptTimeWindow);
          ApptWindow = parseFloat(FsApptTimeWindow);
        }
        else
        {
          MinutesToMinus = MinutesToMinus + parseFloat(selectedERSASetting.dApptTimeWindow);
          ApptWindow = parseFloat(selectedERSASetting.dApptTimeWindow);
        }
        let tempTime = "";
        let selectedApptTime = (e.target ? e.target.value : e);
        if(selectedApptTime !== "")
        {
          tempTime = addsubtractMinutesFromMilitaryTime(selectedApptTime, MinutesToMinus);
          calculatedTimeCheck.current = MinutesToMinus;
          manageDays[indexT][(property.second)] = tempTime;
          const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[indexT].Day);
          if(matchingDays.length > 0)
          {
            const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
              if(item2.Day === manageDays[indexT].Day)
              {
                return {
                  ...item2,
                  [property.second]: tempTime
                }
              }
              return item2;
            });
            setScheduledDisplayDays(updatedSchDisplay);
          }
          if(systemDateTimeRef.current.givenDate === dateGive)
            validateMinScheduleTimeDifference(tempTime, correctFormatDate, manageDaysMultiSch[indexT].Day);
        }
        
      }
    }
    catch(err){console.log(err);}
  };

  const handleApptTimeCheck = (e, type = "", index, property) =>{
    try{
      const manageDays = [...manageDaysMultiSch];
      let timeInput = (Array.isArray(e) ? "" : e.target.value);
      let eventObj = (e);
      let currentTime = systemDateTimeRef.current.time;
      let time1 = (manageDays[index][(property.second)] !== "" ? manageDays[index][(property.second)] : currentTime);
      let time2 = timeInput;
      const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
      let currTimeUserView = "";
      if(time1 === currentTime){currTimeUserView = systemDateTimeRef.current.givenTime;}
      else{currTimeUserView = time1;}
      if(time2 !== "")
      {
        if(parseInt(time1.split(":")[0]) < parseInt(time2.split(":")[0]))
        {
          // manageDays[index][(property.first)] = time2;
          // setManageDaysMultiSch(manageDays);
          handleComputeNewPickupTime(eventObj, index, property);
        }
        else if(parseInt(time1.split(":")[0]) === parseInt(time2.split(":")[0]))
        {
          if(parseInt(time1.split(":")[1]) === parseInt(time2.split(":")[1]))
          {
            
            // manageDays[index][(property.first)] = time2;
            // setManageDaysMultiSch(manageDays);
            handleComputeNewPickupTime(eventObj, index, property);
            
          }
          else if(parseInt(time1.split(":")[1]) > parseInt(time2.split(":")[1]))
          {
            
            setModalHeaderText("Invalid Appointment Time");
            setModalBodyHTML("Please provide a valid appointment time ahead of the time: "+currTimeUserView+".");
            setModalFooterHTML(
              <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);

            manageDays[index][(property.first)] = "";
            setManageDaysMultiSch(manageDays);
            if(matchingDays.length > 0)
            {
              const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                if(item2.Day === manageDays[index].Day)
                {
                  return {
                    ...item2,
                    [property.first]: ""
                  }
                }
                return item2;
              });
              setScheduledDisplayDays(updatedSchDisplay);
            }
            
          }
          else
          {
            // manageDays[index][(property.first)] = time2;
            // setManageDaysMultiSch(manageDays);
            handleComputeNewPickupTime(eventObj, index, property);
          }
        }
        else
        {
          if(parseInt(time1.split(":")[0]) > parseInt(time2.split(":")[0]))
          {
            if(time1 === currentTime)
            {
              // manageDays[index][(property.first)] = time2;
              // setManageDaysMultiSch(manageDays);
              handleComputeNewPickupTime(eventObj, index, property);
            }
            else
            {
              // apptTimeRef.current.blur();
              // manageDays[index][(property.first)] = time2;
              // setManageDaysMultiSch(manageDays);
              handleComputeNewPickupTime(eventObj, index, property);
            }
            
          }
        }
      } 
      else
      {
        // manageDays[index][(property.first)] = time2;
        // setManageDaysMultiSch(manageDays);
        handleComputeNewPickupTime(eventObj, index, property);
      }
    }
    catch(err){console.log(err);}
  };

  const handleExclusionTypeChange = (e) => {
    try{
      let type = e.target.value
      setExclusionType(type);
    }
    catch(err){console.log(err);}
  };

  const getNewDates = (type, val) =>{
    try{
      const manageDays = [...manageDaysMultiSch];
      let itemsChecked = manageDays.filter((item)=> item.Checked);
      if(itemsChecked.length > 0)
      {
        let accumulatedData = [];
        for(let i = 0; i < itemsChecked.length; i++)
        {
          let correctDate = (itemsChecked[i].Date.split("/")[2]+"-"+itemsChecked[i].Date.split("/")[0]+"-"+itemsChecked[i].Date.split("/")[1]);
          let targetDayIndex = new Date(correctDate+" 00:00:00");
          targetDayIndex = targetDayIndex.getDay();
          let datesArr = findDaysInRange((type === "from"? val : multiSchDates.from), (type === "to"? val : multiSchDates.to), targetDayIndex);
          let newData = datesArr.map((date, index2)=>{
            let isHolidayDates = false;
            let formattedDate = (date.split("/")[2]+"-"+date.split("/")[0]+"-"+date.split("/")[1]);
            if(Object.keys(holidayList).length > 0 && holidayList.hasOwnProperty(formattedDate) && holidayList[formattedDate].ExcludedHolidays === "false" && !holidayMsg.includes(date))
            {
              isHolidayDates = true;
            }
            return {Day:manageDays[targetDayIndex].Day, Date:date, Checked:manageDays[targetDayIndex].Checked, WillCall:manageDays[targetDayIndex].WillCall, 
              Appt:manageDays[targetDayIndex].Appt, PUTime:manageDays[targetDayIndex].PUTime, isReturnTrip:manageDays[targetDayIndex].isReturnTrip, 
              ReturnWillCall:manageDays[targetDayIndex].ReturnWillCall, ReturnAppt:manageDays[targetDayIndex].ReturnAppt, 
              ReturnTime:manageDays[targetDayIndex].ReturnTime, schType:manageDays[targetDayIndex].schType, isHoliday:isHolidayDates
            };
          });
          accumulatedData = [...accumulatedData, {Data:newData, Day:targetDayIndex}];
        }

        let fromDateOriginal = (type === "from"? val : multiSchDates.from);
        let toDateOriginal = (type === "to"? val : multiSchDates.to);
        let fromDateFormatted = new Date(fromDateOriginal+" 00:00:00");
        let toDateFormatted = new Date(toDateOriginal+" 00:00:00");
        let currDateChecked = (systemDateTimeRef.current.date ? systemDateTimeRef.current.date : fromDateOriginal);
        let currentDate = new Date(currDateChecked + " 00:00:00");

        if((currentDate < fromDateFormatted || toDateFormatted < currentDate) && !isTimeValidated.isValid)
        {
          setIsTimeValidated({isValid:true, invalidData: []});
        }
        manageDays.forEach((day, index) => {
          if(day.Checked)
          {
            const dateParts = day.Date.split('/');
            const dayDate = new Date(`${dateParts[2]}-${dateParts[0]}-${dateParts[1]} 00:00:00`);
            // Uncheck if outside the range
            if (dayDate < fromDateFormatted || dayDate > toDateFormatted) {
              let filteredDisplayedDays = scheduledDisplayDays.filter((item)=>{
                if(item.Day === day.Day)
                {
                  const dateParts2 = item.Date.split('/');
                  const dayDate2 = new Date(`${dateParts2[2]}-${dateParts2[0]}-${dateParts2[1]} 00:00:00`);
                  return dayDate2 >= fromDateFormatted && dayDate2 <= toDateFormatted;
                }
              });
              if(filteredDisplayedDays.length > 0)
              {
                day.Date = filteredDisplayedDays[0].Date;
              }
              else
              {
                day.Checked = false;
              }
            }
            else if(dayDate.getTime() === fromDateFormatted.getTime() || dayDate.getTime() === toDateFormatted.getTime())
            {
              let newDataDateArr = accumulatedData.find((items) => items.Day === index);
              if(newDataDateArr){day.Date = newDataDateArr.Data[0].Date;}
            }
          } 
        });
    
        setManageDaysMultiSch(manageDays); // Update the state

        setScheduledDisplayDays(prevState => {
          //Remove Duplicates
          const filteredNewData = (prevState !== "" && prevState.length > 0 ? (accumulatedData.filter(item => 
              item.Data.length > 0
            ).flatMap(item => 
              item.Data.filter(newDataItem => 
                !prevState.some(existingItem => 
                  existingItem.Day === newDataItem.Day && existingItem.Date === newDataItem.Date
                )
              )
            )
            
          ) : accumulatedData.flatMap(item=> item.Data));
          //Retain items in prevState that fall in range of given dates
          const updatedState = (prevState && prevState.length > 0 ? prevState.filter((existingItem) => {
            const dateParts = existingItem.Date.split('/');
            const existingDate = new Date(`${dateParts[2]}-${dateParts[0]}-${dateParts[1]} 00:00:00`);
            return existingDate >= fromDateFormatted && existingDate <= toDateFormatted;
          }) : []);
          const combinedData = [...updatedState, ...filteredNewData];
          combinedData.sort((a, b) => {
            let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
            let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
            const dateA = new Date(correctDateA+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
            const dateB = new Date(correctDateB+" 00:00:00"); // Convert MM/DD/YYYY to YYYY-MM-DD for sorting
            return dateB - dateA; // latest to earliest
          });

          let filteredCorrectDay = combinedData.filter((item)=>{return item.Date === systemDateTimeRef.current.givenDate});
          if(filteredCorrectDay.length > 0)
          {
            let correctFormatDate = (filteredCorrectDay[0].Date.split("/")[2]+"-"+filteredCorrectDay[0].Date.split("/")[0]+"-"+filteredCorrectDay[0].Date.split("/")[1]);
            validateMinScheduleTimeDifference(filteredCorrectDay[0].PUTime, correctFormatDate, filteredCorrectDay[0].Day);
          }
          
          return combinedData;
        });
      }
    }
    catch(err){console.log(err);}
  };

  const checkSelectedDates = (type, val) => {
    try{
      if(type === "from")
      {
        let fromDate = new Date(val+" 00:00:00");
        let toDate = new Date(((multiSchDates.to)+" 00:00:00"));
        if(fromDate <= toDate)
        {
          getDaysInRange(val, multiSchDates.to);
          setMultiSchDates({...multiSchDates, from:val});
          getNewDates("from", val);
        }
      }
      else
      {
        let fromDate = new Date(((multiSchDates.from)+" 00:00:00"));
        let toDate = new Date(val+" 00:00:00");
        if(toDate >= fromDate)
        {
          getDaysInRange(multiSchDates.from, val);
          setMultiSchDates({...multiSchDates, to:val});
          getNewDates("to", val);
        }
      }
    }
    catch(err){console.log(err);}
  };
  
  const getValidationMessage = () => {
    const invalidData = isTimeValidated.invalidData;

    if (invalidData.includes("service hour")) {
      return `Note: ${invalidData}`;
    }

    if (invalidData.includes("Standing Order")) {
      return `Note: ${invalidData}`;
    }

    // default case (schedule time check)
    const scheduleDiff = parseInt(
      JSON.parse(ASCSSettingData[parseInt(props.AffID)])
        .find((item) => item.SubTitle === "ScheduleTripMinTimeDiff").value
    ) / 60;

    return `Note: Trip schedule time for [${invalidData[0].split(" ")[2]}] should be at least ${scheduleDiff} minutes greater than current server time [${systemDateTimeRef.current.givenDate} ${systemDateTimeRef.current.givenTime}].`;
  };

  return (
    <>
      {ShowAPILoader ? <div className="loader"></div> : ""}
      {multischModalShow ? 
        <Modal centered backdrop="static" keyboard={true} size="xl"
          onHide={(e)=>{handleHideMultiSchModal("hide");}} show={multischModalShow} animation={true}
        >
          <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>{"Standing Order Multi-Schedule"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            <Row className="border border-dark m-0 rounded" style={{borderRadius:"2px"}}>
              <Col className="d-inline-flex p-1 overflow-auto callAgentSummaryScroller">
                <p className="m-0 user-select-none">{"From:"}</p>
                <input type="date" autoComplete="new_pass" value={multiSchDates.from} onChange={(e)=>{checkSelectedDates("from", e.target.value);}} 
                  className="m-0 mx-1 px-1 w-100 text-center callAgentInputStyle" style={{maxWidth:"150px", maxHeight:"28px"}} min={systemDateTimeRef.current.date}
                />
                <p className="m-0 mx-1 user-select-none">{"To:"}</p>
                <input type="date" autoComplete="new_pass" value={multiSchDates.to} onChange={(e)=>{checkSelectedDates("to", e.target.value);}} 
                 className="m-0 mx-1 px-1 w-100 text-center callAgentInputStyle" style={{maxWidth:"150px", maxHeight:"28px"}} min={systemDateTimeRef.current.date}
                />
                <span className="bg-dark d-block px-1 mx-2" style={{borderRadius:"4px", minWidth:"120px", maxHeight:"28px"}}>
                  <input type="checkbox" className="mx-1" style={{cursor:"pointer"}} checked={neverExpireFlagMultiSch} onChange={(e)=>{setNeverExpireFlagMultiSch(e.target.checked);}}/>
                  <p className="m-0 text-white d-inline-block user-select-none text-nowrap">{"Never Expire"}</p>
                </span>
                {holidayMsg.length !== 0 ? 
                  <p className="m-0 mx-1 user-select-none overflow-hidden text-nowrap" style={{ color:"red", maxWidth:"350px", maxHeight:"32px", textOverflow:"ellipsis"}} 
                  title={"Holidays are defined for "+holidayMsg}
                  >
                    {"Holidays are defined for "}
                    {holidayMsg.map((item, index) => {

                      return(
                        <span key={index}> [{<b>{item}</b>}]</span>
                      );
                      
                    })}
                  </p>
                : ""}
              </Col>
            </Row>
            <Row className="m-0 mt-1 overflow-auto callAgentSummaryScroller" style={{maxHeight:"270px"}}>
              <table className="m-1" style={{maxWidth:"800px"}}>
                <thead>
                  <tr className="text-center text-nowrap">
                    <th className="p-1 user-select-none" style={{width:"100px", minWidth:"100px", maxWidth:"100px"}}>{""}</th>
                    <th className="p-1 user-select-none" style={{width:"90px", minWidth:"80px", maxWidth:"100px"}}>{""}</th>
                    <th className="p-1 user-select-none small">{"Apt Time"}</th>
                    <th className="p-1 user-select-none small">{"Pick Time"}</th>
                    <th className="p-1 user-select-none small" style={{width:"50px", minWidth:"50px", maxWidth:"50px"}} title={"Is Return Trip?"}>{"isRet."}</th>
                    <th className="p-1 user-select-none small" style={{width:"50px",  minWidth:"50px", maxWidth:"50px"}} title={"Return Will Call"}>{"Ret.Call"}</th>
                    <th className="p-1 user-select-none small">{"Ret.Apt"}</th>
                    <th className="p-1 user-select-none small">{"Ret.Time"}</th>
                  </tr>
                </thead>
                <tbody>
                  {manageDaysMultiSch.map((item, index)=>{
                    return(
                      <tr className="text-start" key={index}>
                        <td className="user-select-none small">
                          <input className="mx-1" type="checkbox" checked={item.Checked} 
                            disabled={(daysIncluded.length > 0 && !daysIncluded[index].exists) || (multiSchDates.from === "" || multiSchDates.to === "")}
                            onChange={(e)=>{handleMultiScheduleDaySelect(index);}} style={{cursor:"pointer"}}
                          />
                          <label className="user-select-none">
                            {item.Day}
                          </label>
                        </td>
                        <td className="user-select-none">
                          <input className="mx-1" disabled={!item.Checked} type="checkbox" checked={item.WillCall} 
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].WillCall = !manageDays[index].WillCall;
                              manageDays[index].PUTime = "09:00";
                              manageDays[index].Appt = "";
                              setManageDaysMultiSch(manageDays);
                              if(systemDateTimeRef.current.givenDate === manageDays[index].Date)
                              {
                                if(manageDays[index].WillCall)
                                {
                                  if((manageDays[index].isReturnTrip && manageDays[index].ReturnWillCall) || (!manageDays[index].isReturnTrip && manageDays[index].ReturnWillCall) || (!manageDays[index].isReturnTrip && !manageDays[index].ReturnWillCall))
                                  {
                                    setIsTimeValidated({isValid:true, invalidData: []});
                                  }
                                }
                                else{ 
                                  
                                  validateMinScheduleTimeDifference(manageDays[index].PUTime, manageDays[index].Date, manageDays[index].Day);
                                }
                              }
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      WillCall: !item2.WillCall,
                                      PUTime: "09:00",
                                      Appt: ""
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                              
                            }} 
                            style={{cursor:"pointer"}}
                          />
                          <label className="user-select-none small">{"Will Call"}</label>
                        </td>
                        <td className="user-select-none text-center" style={{width:"110px"}}>
                          <input className="mx-1 text-center callAgentInputStyle" type="time" value={item.Appt} disabled={item.WillCall || !(item.Checked)}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].Appt = e.target.value;
                              if(manageDays[index].Date !== ""){manageDays[index].Date = findDay(multiSchDates.from, multiSchDates.to, index)}
                              setManageDaysMultiSch(manageDays);
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      Appt: e.target.value
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }} 
                            onBlur={(e)=>{handleApptTimeCheck(e, "", index, {first:"Appt", second:"PUTime"});}}
                          />
                        </td>
                        <td className="user-select-none text-center" style={{width:"110px"}}>
                          <input className="mx-1 text-center callAgentInputStyle" type="time" value={item.PUTime} disabled={item.WillCall || !(item.Checked)}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].PUTime = e.target.value;
                              setManageDaysMultiSch(manageDays);
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      PUTime: e.target.value
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }}
                            onBlur={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              if(systemDateTimeRef.current.givenDate === manageDays[index].Date)
                              {
                                validateMinScheduleTimeDifference(e.target.value, manageDays[index].Date, manageDays[index].Day);
                              }
                            }} 
                          />
                        </td>
                        <td className="user-select-none text-center">
                          <input className="mx-1" disabled={!item.Checked} style={{cursor:"pointer"}} type="checkbox" checked={item.isReturnTrip}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].isReturnTrip = !manageDays[index].isReturnTrip;
                              setManageDaysMultiSch(manageDays);
                              if(systemDateTimeRef.current.givenDate === manageDays[index].Date)
                              { 
                                let willCall = manageDays[index].WillCall;
                                let returnWC = manageDays[index].ReturnWillCall;
                                if(manageDays[index].isReturnTrip && !returnWC){
                                  validateMinScheduleTimeDifference(manageDays[index].ReturnTime, manageDays[index].Date, manageDays[index].Day);
                                }
                                else
                                {
                                  if((willCall && returnWC))
                                    setIsTimeValidated({isValid:true, invalidData: []});
                                }
                              }
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      isReturnTrip: !item2.isReturnTrip
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }} 
                          />
                        </td>
                        <td className="user-select-none text-center">
                          <input className="mx-1" disabled={!item.Checked} style={{cursor:"pointer"}} type="checkbox" checked={item.ReturnWillCall}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].ReturnWillCall = !manageDays[index].ReturnWillCall;
                              manageDays[index].ReturnTime = "09:00";
                              manageDays[index].ReturnAppt = "";
                              setManageDaysMultiSch(manageDays);
                              if(systemDateTimeRef.current.givenDate === manageDays[index].Date)
                              {
                                if(manageDays[index].ReturnWillCall){setIsTimeValidated({isValid:true, invalidData: []});}
                                else if(manageDays[index].isReturnTrip){validateMinScheduleTimeDifference(manageDays[index].ReturnTime, manageDays[index].Date, manageDays[index].Day);}
                              }
                              if(manageDays[index].Date !== ""){manageDays[index].Date = findDay(multiSchDates.from, multiSchDates.to, index)}
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      ReturnWillCall: !item2.ReturnWillCall,
                                      ReturnTime: "09:00",
                                      ReturnAppt: ""
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }} 
                          />
                        </td>
                        <td className="user-select-none text-center" style={{width:"110px"}}>
                          <input className="mx-1 text-center callAgentInputStyle" type="time" value={item.ReturnAppt} 
                            disabled={(item.isReturnTrip && item.ReturnWillCall) || !(item.Checked) || (item.Checked && !item.isReturnTrip)}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].ReturnAppt = e.target.value;
                              setManageDaysMultiSch(manageDays);
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      ReturnAppt: e.target.value
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }} 
                            onBlur={(e)=>{handleApptTimeCheck(e, "", index, {first:"ReturnAppt", second:"ReturnTime"});}}
                          />
                        </td>
                        <td className="user-select-none text-center" style={{width:"110px"}}>
                          <input className="mx-1 text-center callAgentInputStyle" type="time" value={item.ReturnTime} 
                            disabled={(item.isReturnTrip && item.ReturnWillCall) || !(item.Checked) || (item.Checked && !item.isReturnTrip)}
                            onChange={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              manageDays[index].ReturnTime = e.target.value;
                              setManageDaysMultiSch(manageDays);
                              const matchingDays = scheduledDisplayDays.filter(item => item.Day === manageDays[index].Day);
                              if(matchingDays.length > 0)
                              {
                                const updatedSchDisplay = scheduledDisplayDays.map(item2 => {
                                  if(item2.Day === manageDays[index].Day)
                                  {
                                    return {
                                      ...item2,
                                      ReturnTime: e.target.value
                                    }
                                  }
                                  return item2;
                                });
                                setScheduledDisplayDays(updatedSchDisplay);
                              }
                            }} 
                            onBlur={(e)=>{
                              const manageDays = [...manageDaysMultiSch];
                              if(manageDays[index].isReturnTrip && systemDateTimeRef.current.givenDate === manageDays[index].Date)
                                validateMinScheduleTimeDifference(e.target.value, manageDays[index].Date, manageDays[index].Day);
                            }} 
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <Col className="border border-dark p-0 p-1 my-1 overflow-auto rounded" style={{borderRadius:"2px", maxWidth:"298px"}}>
                <Row className="w-100 m-0">
                  <Col xs={5} className="text-center justify-content-center p-0">
                    <p className="m-0 user-select-none text-nowrap overflow-hidden small">{"Sch. Days"}</p>
                    <span className="text-center justify-content-center justify-items-center d-flex">
                      <ul style={{width:"auto", maxWidth:"140px", height:"200px", overflowY:"auto", borderRadius:"4px"}} className="border border-secondary w-100 p-0 m-0">
                        {scheduledDisplayDays !== "" && scheduledDisplayDays.length > 0 ? scheduledDisplayDays
                          .filter(item => {
                            return !((exclusionType === "Holidays" && !item.isHoliday) || (exclusionType === "Non-Holidays" && item.isHoliday));
                          })
                          .filter(item => item.Checked && item.schType === "sch")
                          .map((item, index)=>{ 
                          
                            let date = (item.Date !== "" ? item.Date : findDay(multiSchDates.from, multiSchDates.to, index));
                            if(date !== "N/A")
                            {
                              return(
                                <li key={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow small"
                                  style={{cursor:"pointer"}} tabIndex={-1} 
                                  onClick={(e)=>{
                                    setScheduledDisplayDays(prevState => {
                                      const updatedDays = prevState.map((item2, index2) =>{
                                        if (item2.Date === item.Date) {
                                          return { ...item2, schType: "exc" }; // Update schType for the current item
                                        }
                                        return item2;
                                      });
                                      updatedDays.sort((a, b) => {
                                        let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
                                        let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
                                        const dateA = new Date(correctDateA+" 00:00:00"); 
                                        const dateB = new Date(correctDateB+" 00:00:00");
                                        return dateB - dateA; // Sort latest to earliest
                                      });
                                      return updatedDays;
                                    });
                                  }}
                                >
                                  {item.Day.slice(0,3) +" "+ date}
                                </li>
                              );
                            }
                            return null; //for date "N/A" don't render this option
                          })
                        : ""}
                      </ul>
                    </span>
                  </Col>
                  <Col xs={2} className="text-center my-auto p-0">
                    <Icon icon="bx:transfer" className="" style={{width:"15px", height:"15px"}}/>
                  </Col>
                  <Col xs={5} className="text-center p-0">
                    <p className="m-0 user-select-none text-nowrap overflow-hidden small">{"Excluded"}</p>
                    <span className="text-center justify-content-center justify-items-center d-flex">
                      <ul style={{width:"auto", maxWidth:"140px", height:"200px", overflowY:"auto", borderRadius:"4px"}} className="border w-100 border-secondary p-0 m-0">
                        {scheduledDisplayDays !== "" && scheduledDisplayDays.length > 0 ? scheduledDisplayDays
                          .filter(item => {
                            return !((exclusionType === "Holidays" && !item.isHoliday) || (exclusionType === "Non-Holidays" && item.isHoliday));
                          })
                          .filter(item => item.Checked && item.schType === "exc")
                          .map((item, index)=>{
                            let date = (item.Date !== "" ? item.Date : findDay(multiSchDates.from, multiSchDates.to, index));
                            if(date !== "N/A")
                            {
                              return(
                                <li key={index} className="border-bottom text-nowrap overflow-hidden addressSelectionRow small"
                                  style={{cursor:"pointer"}} tabIndex={-1} 
                                  onClick={(e)=>{
                                    setScheduledDisplayDays(prevState => {
                                      const updatedDays = prevState.map((item2, index2) =>{
                                        if (item2.Date === item.Date) {
                                          return { ...item2, schType: "sch" }; // Update schType for the current item
                                        }
                                        return item2;
                                      });
                                      updatedDays.sort((a, b) => {
                                        let correctDateA = (a.Date.split('/')[2] +"-"+ a.Date.split('/')[0] +"-"+ a.Date.split('/')[1]);
                                        let correctDateB = (b.Date.split('/')[2] +"-"+ b.Date.split('/')[0] +"-"+ b.Date.split('/')[1]);
                                        const dateA = new Date(correctDateA+" 00:00:00"); 
                                        const dateB = new Date(correctDateB+" 00:00:00");
                                        return dateB - dateA; // Sort latest to earliest
                                      });
                                      return updatedDays;
                                    });
                                  }}
                                >
                                  {item.Day.slice(0,3) +" "+ date}
                                </li>
                              );
                            }
                            return null; //for date "N/A" don't render this option
                          })
                        : ""}
                      </ul>
                    </span>
                    
                  </Col>
                </Row>
                <Row className="m-0 overflow-auto callAgentSummaryScroller">
                  <Col className="p-0">
                    <span>
                      <p className="m-0 d-inline-flex user-select-none text-nowrap overflow-hidden small">{"Exclusion Type"}</p>
                      <select className="mx-1 mt-1 text-center overflow-hidden callAgentInputStyle" value={exclusionType}  onChange={handleExclusionTypeChange} 
                        style={{maxHeight:"25px", textOverflow:"ellipsis"}}
                      >
                        <option value={"All"}>All</option>
                        <option value={"Holidays"}>Holidays</option>
                        <option calue={"Non-Holidays"}>Non-Holidays</option>
                      </select>
                    </span>

                  </Col>
                </Row>
              </Col>
            </Row>
            
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 d-block py-1'>
            <Row className='m-0'>
              {!isTimeValidated.isValid && isTimeValidated.invalidData.length > 0 ?
                <Col xs={9} className='d-inline-flex text-start justify-content-start my-auto'>
                  <p className='m-0 user-select-none justify-content-start text-nowrap overflow-hidden text-danger text-start'
                    style={{ textOverflow: "ellipsis" }}
                    title={getValidationMessage()}
                  >
                    {getValidationMessage()}
                  </p>
                </Col>
              : ""}
              <Col xs={`${(!isTimeValidated.isValid && isTimeValidated.invalidData.length > 0 ? 3 : 12)}`} className='text-end justify-content-end'>
                <Button variant="dark" className="mx-1" title={"Apply multischedule"} onClick={(e)=>{
                  if((!isTimeValidated.invalidData.includes("service hour") && isTimeValidated.isValid) || (isTimeValidated.invalidData.includes("service hour")) 
                  || (isTimeValidated.invalidData.includes("Standing Order"))){handleApplyMultiSchedule(e);}
                  else{
                    setModalHeaderText("Apply Schedule Error");
                    setModalBodyHTML(<b>{"Please resolve the time issue before saving trip schedule."}</b>);
                    setModalFooterHTML(
                      <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                        OK
                      </Button>
                    );
                    setShowDynamicModal(true);
                  }
                  
                }}
                >
                  Apply
                </Button>
                <Button variant="secondary" className="mx-1" title={"Clear current schedule"} onClick={handleClearMultiSchedule}>Clear</Button>
              </Col>
            </Row>
            
          </Modal.Footer>
          
        </Modal>
      :""}
      {showDynamicModal ? 
        <Modal centered backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
              setShowDynamicModal(false);
            }
          }} 
          onHide={()=>{setShowDynamicModal(false);}} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}
    </>
  );
};

export default MultiSchedule;
